import React from "react";
import "@/App.css";
import { ThemeProvider } from "@/context/ThemeProvider";
import { useLenis } from "@/hooks/useLenis";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Solutions from "@/components/Solutions";
import WhyChooseUs from "@/components/WhyChooseUs";
import About from "@/components/About";
import Experience from "@/components/Experience";
import Industries from "@/components/Industries";
import Services from "@/components/Services";
import FeatureCarousel from "@/components/FeatureCarousel";
import WhyTrust from "@/components/WhyTrust";
import Benefits from "@/components/Benefits";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useLenis();
  return (
    <ThemeProvider>
      <div className="App relative">
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Solutions />
          <WhyChooseUs />
          <About />
          <Experience />
          <Industries />
          <Services />
          <FeatureCarousel />
          <WhyTrust />
          <Benefits />
          <Contact />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
